import axios from 'axios';

const url = process.env.REACT_APP_URL_API;

const api = axios.create({
  baseURL: url,
});

export default api;
